import React, { createContext, useContext, useState, useEffect } from "react";
import { translations, getNested } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ofa_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("ofa_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const value = getNested(translations[lang], path);
    if (value !== undefined) return value;
    return getNested(translations.en, path) || path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
